<template>
  <div class="mid-policy">
    
    <el-row class="__inner">
      <el-col :span="17" class="banner">
        <div class="title">
          <svg-icon icon-name="home-regulatory" :size="16" class="mr-5"></svg-icon>
          <span>{{ $t('clientDashboard.regulatoryPolicy') }}</span>
        </div>
        <div class="banner-content">
          <el-carousel style="height: 100%;">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <img :src="item.imgSrc" :alt="item.name" @click="openLink(item.linkUrl)" :title="item.name" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="7" class="news">
        <Insights></Insights>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SvgIcon from "@/components/svgIcon/index";
import Insights from './Insights.vue'

import { regulatoryPolicyList } from './data'

export default {
  name: 'MidPolicy',
  components: {
    SvgIcon,
    Insights,
  },
  data() {
    return {}
  },
  computed: {
    bannerList() {
      return [...regulatoryPolicyList.banner[this.$i18n.locale]]
    },
  },
  methods: {
    openLink(url) {
      window.open(url)
    },
  }
}
</script>

<style scoped>
.mid-policy {
  height: 100%;
  padding: 0 var(--spacing) var(--spacing) var(--spacing);

  --spacing: 15PX;
  --title-height: 46PX;
  --news-height: 50PX;
}

.mid-policy .title {
  height: var(--title-height);
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12PX;
}

.mid-policy .__inner {
  height: 100%;
}

.mid-policy .__inner .el-col {
  height: 100%;
}

.mid-policy .banner {
  padding-right: var(--spacing);
}

.mid-policy .banner .banner-content {
  height: calc(100% - var(--title-height));
  border-radius: 10px;
  overflow: hidden;
}

.banner-content img {
  cursor: pointer;
  width: 100%;
  object-fit: cover;
  /* height: 280PX; */
  /* object-fit: cover; */
}

::v-deep .el-carousel__container {
  height: 100% !important;
}

.mid-policy .news {
  height: 100%;
  overflow-y: overlay;
  overflow-x: hidden;
}

.mid-policy .news::-webkit-scrollbar {
  width: 6PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6PX !important;
}

.mid-policy .news::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 11PX;
  background-color: transparent !important;
  transition: background-color 0.3s;
}

.mid-policy .news:hover::-webkit-scrollbar-thumb {
  background-color: hsla(220, 4%, 58%, 0.3) !important;
}

.news .item {
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
  margin-bottom: 10PX;
  height: var(--news-height);
}

.news .item img {
  width: var(--news-height);
  height: var(--news-height);
  flex-shrink: 0;
  border-radius: 5px;
  object-fit: cover;
}

.news .item .info {
  width: 100%;
  padding: 5px 10px;
  line-height: 20PX;
}

.news .item .name {
  font-size: 13PX;
  font-weight: bolder;
  width: calc(100% - var(--news-height));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
}

.news .item .desc {
  width: calc(100% - var(--news-height));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #a09c9c;
}
</style>